var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinmarketcap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 29 28",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 16.7c-.5.3-1 .4-1.5.1-.6-.3-.9-1-.9-2v-3c0-1.6-.6-2.6-1.6-2.9-1.7-.5-3 1.5-3.5 2.3l-3 4.7v-5.7c0-1.4-.5-2.2-1.3-2.4-.6-.2-1.4-.1-2.2 1.1l-6.7 10.5c-1-1.7-1.4-3.5-1.4-5.4 0-6.3 5.2-11.5 11.6-11.5s11.8 5.2 11.8 11.5c0 1.3-.4 2.3-1.2 2.7zm3.8-2.7c0-7.8-6.4-14-14.3-14-7.8 0-14.2 6.3-14.2 14s6.4 14 14.2 14c3.6 0 7-1.3 9.7-3.7.5-.5.6-1.3 0-1.8-.2289-.2461-.5442-.394-.8799-.4127-.3356-.0186-.6653.0934-.9201.3127-2.2964 2.0772-5.3225 3.1594-8.4153 3.0094-3.0928-.1499-6.00006-1.5198-8.0847-3.8094l6-9.4v4.3c0 2.1.9 2.8 1.6 3s1.8 0 2.9-1.7l3.3-5.2.3-.5v2.7c0 2 .8 3.5 2.2 4.3 1.3.7 3 .6 4.2-.2 1.6-1 2.4-2.8 2.4-4.9z",
    fill: "#D3D5D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinmarketcap);
export default __webpack_public_path__ + "static/media/coinmarketcap.f7717c49e7cabbe2c010fc26a4d32dd4.svg";
export { ForwardRef as ReactComponent };